import { Component } from '@angular/core';

@Component({
    templateUrl: 'forbidden.view.html',
    styleUrls: ['../not-found/not-found.style.scss'],
})
export class ForbiddenView {}
